import React from "react";
import "./Map.scss";
declare const google: any;

const Map = ({ clusterData, stateCord }: any) => {
  React.useEffect(() => {
    if (Object.keys(clusterData)?.length) {
      const map = new google.maps.Map(document.getElementById("googleMap"), {
        zoom: 7,
        center: new google.maps.LatLng(
          stateCord?.lat && stateCord.lng ? stateCord.lat : 25.7617,
          stateCord?.lat && stateCord.lng ? stateCord.lng : -80.496929
        ),
        mapTypeControl: false,
        streetViewControl: true,
      });

      new google.maps.Marker({
        position: stateCord,
        map,
        scaledSize: new google.maps.Size(35, 35), // scaled size
      });
      const keys = Object.keys(clusterData);
      for (let i = 0; i < keys?.length; i++) {
        for (let j = 0; j < clusterData[keys[i]]?.data?.length; j++) {
          const myLatLng = {
            lat: clusterData[keys[i]]?.data[j]?.latitude
              ? Number(clusterData[keys[i]]?.data[j]?.latitude)
              : 37.6597307,
            lng: clusterData[keys[i]]?.data[j]?.longitude
              ? Number(clusterData[keys[i]]?.data[j]?.longitude)
              : -121.8975718,
          };
          new google.maps.Marker({
            position: myLatLng,
            map,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 8.5,
              fillColor: "#FFF",
              fillOpacity: 0.4,
              strokeColor: clusterData[keys[i]]?.color,
              strokeWeight: 4,
            },
          });
        }
      }
    }
  }, [clusterData, stateCord]);
  return <div id="googleMap"></div>;
};

export default Map;
